export default {
  'ja': {
    'user_list': {
      'employee': '社員',
      'retiree': '退職者',
      'label': {
        'user_no': 'ID',
        'user_name': '社員名',
        'shop_name': '店舗名',
        'age': '年齢',
        'user_type': '役職',
        'joined_date': '入社日',
        'change_date': '役職異動日',
        'overed_date': '退職日'
      }
    },
    'shop_list': {
      'responsible_person': '店舗',
      'label': {
        'shop_name': '店舗名',
        'address': '住所',
        'tel': '電話番号'
      }
    },
    'user_change_list': {
      'change': '役職異動日',
      'label': {
        'user_no': 'ID',
        'user_name': '社員名',
        'shop_name': '店舗名',
        'age': '年齢',
        'user_type': '役職',
        'change_date': '役職異動日'
      }
    },
    'user_photo_list': {
      'photo': '写真'
    },
    'rejectreason_list': {
      'label': {
        'id': 'ID',
        'reject_reason': '却下理由',
        'reject_reason_default_content': '初期表示却下コメント',
        'reject_reason_priority': '表示優先度'
      }
    },
    'usertype': {
      'list': {
        'Name': '役職名',
        'Default': '権限',
        'Priority': '表示優先度',
        'Employee': '社員区分'
      },
      'type1': 'システム管理者',
      'type2': '店舗管理者以上',
      'type3': '自店入力者',
      'type4': '自店閲覧者',
      'employee': 'ACCESS連携',
      'not_employee': 'ACCESS連携外'
    },
    'turnover_class': {
      'class1': '自己都合',
      'class2': '契約満了',
      'class3': '定年退職',
      'class4': '解雇',
      'class5': '死亡',
      'class6': 'その他'
    },
    'domain': {
      'list': {
        'No': 'ドメインNo',
        'Name': 'ドメイン名',
        'Content': 'ドメイン内容'
      }
    },
    'businesstype': {
      'list': {
        'Work': '役職名',
        'Detail': '業務内容'
      }
    },
    'turnover': {
      'list': {
        'Group': '離職区分',
        'Content': '離職事由'
      }
    },
    'join': {
      'list': {
        'Class': '入社経緯'
      }
    },
    'unit': {
      'minute': '分',
      'hour': '時間',
      'day': '日'
    },
    'login': {
      'forgot_password': 'パスワードをリセットする'
    },
    'forgot_password': {
      'input_email': '自分のメールアドレスをご入力してください。',
      'send_reset_email': 'パスワードをリセットするためのリンクが含まれているメールが入力したメールアドレスへ送信されます。',
      'back_to_login': 'すでにアカウントを持っていますか？',
      'completed': 'パスワードリセット用メールをお客様のメールアドレスへ届けました。メールからリンクをクリックして、パスワードをリセットしてください。'
    },
    'reset_password': {
      'input_new_password': '新しいパスワードを入力してください。',
      'reset_cancel': {
        'message1': 'パスワード変更を取消し',
        'message2': 'します。'
      },
      'completed': 'パスワードが変更されました。'
    },
    'shop_manager_list': {
      'label': {
        'shop_name': '店舗名',
        'shop_manager_name': '店舗管理者'
      }
    },
    'shop_manager_edit': {
      'label': {
        'name': '社員名',
        'age': '年齢',
        'user_type': '役職',
        'join_date': '入社日'
      }
    },
    'shift_creator_list': {
      'label': {
        'shop_name': '店舗名',
        'shift_creator_name': 'シフト作成者'
      }
    },
    'shift_creator_edit': {
      'label': {
        'name': '社員名',
        'age': '年齢',
        'user_type': '役職',
        'join_date': '入社日'
      }
    },
    'supplier': {
      'label': {
        'name': 'サプライヤー名',
        'name_hurigana': 'サプライヤー名ふりがな',
        'responsible_name': '担当者名',
        'tel_no': 'TEL',
        'fax_no': 'FAX',
        'mail': 'メールアドレス',
        'postal_code': '郵便番号',
        'address': '住所',
        'order_method': '出力方法'
      }
    },
    'consumableItem': {
      'label': {
        'name': '消耗品名',
        'kana': 'ふりがな',
        'code': '型番',
        'category': 'カテゴリー',
        'supplier': 'サプライヤー',
        'price': '単価',
        'lot price': '1ロットあたりの単価',
        '1 per': '1個あたり',
        '1 lot per': '1ロットあたり',
        'quantity': 'の数量',
        'unit': '単位',
        'order reception': '発注受付',
        'size': 'サイズ規格',
        'just stock number': '必要在庫数',
        'stock quantity': '現在在庫数',
        'order quantity': '発注数'
      }
    },
    'category': {
      'label': {
        'name': 'カテゴリー名',
        'name_hurigana': 'カテゴリー名ふりがな'
      }
    },
    'holdPlace': {
      'label': {
        'name': '保管場所名',
        'shop_name': '店舗名'
      }
    },
    'shopConsumableItem': {
      'label': {
        'consumable_item_name': '消耗品名',
        'shop_name': '店舗名',
        'just_stock_number': '必要在庫数'
      }
    },
    'shopOrder': {
      'label': {
        'date': '店舗依頼日',
        'name': '店舗名',
        'status': 'ステータス',
        'order responsible': '発注担当者名',
        'change state': '変更状態',
        'year month week': '年月 週数'
      }
    },
    'tanomail': {
      'label': {
        'shop_name': '店舗名',
        'represent_code': '代表コード(タイラ企業コード)',
        'group_code': 'グループコード(店舗コード)',
        'login_id': 'ログインID',
        'password': 'パスワード',
        'management_number': '貴社管理番号',
        'receive_responsible': '受取担当者名'
      }
    },
    'Yes': 'はい',
    'No': 'いいえ',
    'Home': 'ホーム',
    'User Shop': '社員・店舗',
    'User': '社員',
    'User List': '社員一覧',
    'User Photo List': '写真一覧',
    'User Detail': '社員詳細',
    'User New': '社員新規登録',
    'User Edit': '社員編集',
    'User Over': '離職登録',
    'User History': '履歴確認',
    'User Pdf': '書類保存',
    'Shop History': '店舗異動',
    'Shop History Force Edit': '店舗履歴編集',
    'Usertype History': '役職異動',
    'Usertype History Force Edit': '役職履歴編集',
    'Retiree List': '退職者一覧',
    'User Change List': '役職異動日一覧',
    'Master Manage': 'マスタ管理',
    'ACCESS': 'ACCESS連携',
    'Message': 'メッセージ確認',
    'Moral': 'モラル確認',
    'Moral List': '登録一覧',
    'Moral Detail': 'モラル確認詳細',
    'Moral New': 'モラル確認新規',
    'Moral Edit': 'モラル確認編集',
    'Moral Result List': '回答確認',
    'Shop Manager': '店舗管理者',
    'Shop Manager List': '店舗管理者一覧',
    'Shop Manager Edit': '店舗管理者編集',
    'Shop Manager Clear': '管理者クリア',
    'Human Staff': '人事担当者',
    'Human Staff List': '人事担当者一覧',
    'Human Staff Edit': '人事担当者編集',
    'Shift Creator': 'シフト作成者',
    'Shift Creator List': 'シフト作成者一覧',
    'Shift Creator Edit': 'シフト作成者編集',
    'Shift Creator Clear': 'シフト作成者クリア',
    'Magazine': '社内報',
    'Magazine List': '社内報一覧',
    'Magazine New': '社内報新規',
    'Magazine Edit': '社内報編集',
    'ShiftManage': 'シフト管理',
    'ShiftAttendance': '出勤簿印刷',
    'ShiftCreate': 'シフト作成',
    'ShiftClass': '固定シフト登録',
    'ShiftCondition': '勤務条件登録',
    'ShiftConditionEdit': '勤務条件編集',
    'Propose': '提案制度',
    'Propose Unapproved List': '承認前一覧',
    'Propose Approved List': '採用前一覧',
    'Propose Result': '集計',
    'Propose Title': '課題提案',
    'Propose Title Detail': '課題詳細',
    'Propose Title Create': '課題登録',
    'Propose Title Edit': '課題編集',
    'Propose Unapproved Detail': '承認前詳細',
    'Propose Approved Detail': '採用前詳細',
    'User Type': '役職',
    'User Type List': '役職一覧',
    'User Type New': '役職新規登録',
    'User Type Detail': '役職詳細',
    'User Type Edit': '役職編集',
    'Domain Type': 'ドメイン',
    'Domain Type List': 'ドメイン一覧',
    'Domain Type New': 'ドメイン新規登録',
    'Domain Type Detail': 'ドメイン詳細',
    'Domain Type Edit': 'ドメイン編集',
    'Turnover Type': '離職事由',
    'Turnover Type List': '離職事由一覧',
    'Turnover Type New': '離職事由新規登録',
    'Turnover Type Detail': '離職事由詳細',
    'Turnover Type Edit': '離職事由編集',
    'Business Type': '業務内容',
    'Business Type List': '業務内容一覧',
    'Business Type New': '業務内容新規登録',
    'Business Type Detail': '業務内容詳細',
    'Business Type Edit': '業務内容編集',
    'Join Type': '入社経緯',
    'Join Type List': '入社経緯一覧',
    'Join Type New': '入社経緯新規登録',
    'Join Type Detail': '入社経緯詳細',
    'Join Type Edit': '入社経緯編集',
    'Shop': '店舗',
    'Shop List': '店舗一覧',
    'Shop New': '店舗新規登録',
    'Shop Detail': '店舗詳細',
    'Shop Edit': '店舗編集',
    'Reject Reason': '却下理由',
    'Reject Reason List': '却下理由一覧',
    'Reject Reason New': '却下理由新規登録',
    'Reject Reason Detail': '却下理由詳細',
    'Reject Reason Edit': '却下理由編集',
    'Guideline': 'モラル行動指針',
    'Guideline List': 'モラル行動指針一覧',
    'Guideline New': 'モラル行動指針新規登録',
    'Guideline Detail': 'モラル行動指針詳細',
    'Guideline Edit': 'モラル行動指針編集',
    'Questions': '360°評価',
    'Questions List': '360°評価一覧',
    'Questions New': '360°評価新規',
    'Questions Detail': '360°評価詳細',
    'Questions Edit': '360°評価編集',
    'Step Up': '360°多面評価',
    'Step Up List': 'ステップアップ者登録一覧',
    'Step Up Detail': 'ステップアップ者登録詳細',
    'Step Up New': 'ステップアップ者登録新規',
    'Step Up Edit': 'ステップアップ者登録編集',
    'Step Up Result List': '研修評価回答確認',
    'Normal Questions': '常態評価',
    'Normal Questions List': '常態評価一覧',
    'Normal Questions New': '常態評価新規',
    'Normal Questions Detail': '常態評価詳細',
    'Normal Questions Edit': '常態評価編集',
    'Ability Questions': '能力評価',
    'Ability Questions List': '能力評価一覧',
    'Ability Questions New': '能力評価新規',
    'Ability Questions Detail': '能力評価詳細',
    'Ability Questions Edit': '能力評価編集',
    'Evaluate Questions': '人事評価',
    'Evaluate Questions New': '評価対象登録新規',
    'Evaluate Questions List': '人事評価登録一覧',
    'Evaluate Questions Result List': '人事評価回答確認',
    'Evaluate Questions Detail': '人事評価詳細',
    'Evaluate Questions Edit': '人事評価編集',
    'Master Service Questions': '接客評価マスタ',
    'Master Service Questions New': '接客評価マスタ登録',
    'Master Service Questions Detail': '接客評価マスタ詳細',
    'Master Service Questions List': '接客評価マスタ一覧',
    'Master Service Questions Edit': '接客評価マスタ編集',
    'Service Questions': '接客評価',
    'Service Questions New': '接客評価対象登録新規',
    'Service Questions List': '接客評価登録一覧',
    'Service Questions Result List': '接客評価回答確認',
    'Service Questions Result Detail': '接客評価回答詳細',
    'Service Questions Detail': '接客評価詳細',
    'Service Questions Edit': '接客評価編集',
    'Machine Order Shop': '遊技台発注店舗管理',
    'Es Mycard': 'ESmyカード',
    'Company Notice': '全社通達',
    'Company Notice List': '全社通達登録一覧',
    'Company Notice Detail': '全社通達詳細',
    'Company Notice Edit': '全社通達編集',
    'Company Notice New': '全社通達登録',
    'Company Notice Result': '全社通達集計',
    'Stock': '在庫管理',
    'Comfirm Order': '発注依頼確認',
    'Comfirm Order Detail': '発注依頼詳細',
    'Order History': '発注履歴',
    'Order History Store List': '発注履歴店舗一覧',
    'Order History Store Detail': '発注履歴店舗詳細',
    'Master Stock': '在庫管理マスタ',
    'Stock Analysis': '在庫分析',
    'Master Supplier': 'サプライヤー',
    'Master Supplier New': 'サプライヤー新規登録',
    'Master Supplier Edit': 'サプライヤー編集',
    'Master Consumable Item': '消耗品',
    'Master Consumable Item List': '消耗品一覧',
    'Master Consumable Item New': '消耗品新規登録',
    'Master Consumable Item Edit': '消耗品編集',
    'Confirm Shop Stock Consumable Item Count': '店舗の必要在庫数を確認',
    'Shop Stock Consumable Item Count List': '店舗の必要在庫数一覧',
    'Shop Stock Consumable Item Count Edit': '店舗の必要在庫数登録',
    'Master Category': 'カテゴリー',
    'Master Category New': 'カテゴリー新規登録',
    'Master Category Edit': 'カテゴリー編集',
    'Master Tanomail': 'たのめーるアカウント',
    'Master Tanomail List': 'たのめーるアカウント一覧',
    'Master Tanomail New': 'たのめーるアカウント新規登録',
    'Master Tanomail Edit': 'たのめーるアカウント編集',
    'Consumable Item Info': '消耗品情報',
    'My Profile': 'マイページ',
    'Safety Confirmation': '安否確認',
    'Safety Confirmation List': '安否確認一覧',
    'Safety Confirmation Answer List': '安否確認報告一覧',
    'Safety Confirmation New': '安否確認登録',
    'Safety Confirmation Edit': '安否確認編集',
    'Safety Confirmation Save': '安否確認を登録し公開',
    'Safety Confirmation Update': '安否確認を更新',
    'Safety Confirmation Close': '公開を終了する',
    'Confrim Closing Safety Confirmation': '安否確認の公開を終了して良いですか？',
    'Deadline Notice': 'お知らせ',
    'Login': 'ログイン',
    'Logout': 'ログアウト',
    'Read More': 'さらに読み込む',
    'Read All': 'すべて見る',
    'Close': '閉じる',
    'age': '{age}歳',
    'New Registration': '新規登録',
    'Print': '名簿一覧印刷',
    'My Shop Print': '自店名簿一覧印刷',
    'Csv Download': 'データ出力',
    'Pdf Download': 'PDF出力',
    'Back': '戻る',
    'Show': '表示',
    'Edit': '編集',
    'Show Edit': '詳細・編集',
    'Save': '保存',
    'Delete': '削除',
    'Register': '登録',
    'Cancel': 'キャンセル',
    'Detail': '詳細',
    'Login ID': 'ID',
    'Password': 'パスワード',
    'Need to login': 'ログインしてください。',
    'No Data': 'データがありません。',
    'Delete Confirm': '削除すると元に戻すことはできません。\n本当に削除しますか？',
    'Retire Cancel Confirm': '退職を本当に取り消しますか？',
    'Approve Confirm': '提案が承認されます。\nWONDER WORLDに表示されます。',
    'Not Approve Confirm': '提案投稿者へ差し戻しされます。',
    'Adopt Confirm': '提案が採用されます。\nWONDER WORLDに表示されます。',
    'Update Successful': '正常に更新されました。',
    'Notice Confirm': 'このお知らせを削除しますか？',
    'Avatar Upload Successful': '写真をアップロードしました。',
    'Mail Address': 'メールアドレス',
    'Current Password': '現在のパスワード',
    'New Password': '新しいパスワード',
    'New Password Retyped': '新しいパスワード(確認)',
    'Password Reset': 'パスワードリセット',
    'Reset': 'リセット',
    'Send': '送信',
    'Image Upload Message': 'ここにファイルをドロップしてください',
    'Image Upload Successful': 'ファイルをアップロードしました。',
    'Image Upload Error': '失敗：画像ファイルを貼り付けてください',
    'validations': {
      'required': '必須項目です。',
      'password_rule': '4文字以上10文字以下の英数字を入力してください。',
      'password_confirmation': '同じパスワードを入力してください。',
      'invalid_furigana': 'ひらがなを入力してください。',
      'invalid_number': '半角数字で入力してください。',
      'not_hyphen': '「-」なしで入力してください',
      'fomat_tel': '電話番号形式で入力してください',
      'fomat_fax': 'FAX番号形式で入力してください',
      'before_today': '本日以前を入力して下さい。',
      'after_release': '2018年1月4日以降を入力して下さい。',
      'after_today': '明日以降を入力して下さい。',
      'integrity': '抽出開始日＞抽出終了日になっています。',
      'check': '一つ以上選択してください。',
      'same_selected_value': '同一選択肢名が存在します。',
      'date_range': '翌月までしか入力できません。'
    },
    'Will Must': 'MUST・WILL',
    'Referral': '友達紹介',
    'ReferralList': '友達紹介一覧',
    'Maintenance': 'メンテナンス中です。しばらくお待ちください。',
    'user': {
      'remove_success_message': '名簿を削除しました。'
    },
    'Confirmed Message': '確認した'
  }
}



// WEBPACK FOOTER //
// ./src/i18n.js